<div class="auth-layout">
    <mat-card class="auth-card">
      <div class="flex flex-col items-center gap-2 bg-neutral-800 px-8 py-8">
        <img src="https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/nustone-icon-white+(1).svg"
          alt="Nustone"
          class="h-10 w-auto" />
        <span class="text-amber-400 font-bold text-xs tracking-widest uppercase">Back Office</span>
      </div>
      <div class="px-8 py-8">
        <ng-content></ng-content>
      </div>
    </mat-card>
</div>
